<div class="container admin">
  <!-- Falls die API-Abfrage einen Fehler liefert, wird der Fehlertext angezeigt -->
  @if (templateList.value(); as templateList) {
    <div class="row admin">
      <p class="admin-warning"><b>{{ 'admin.warning' | translate }}</b></p>
    </div>
    <div class="row admin">
      <div class="col-sm-4 pl-0 mb-0"><p class="admin"><b>&nbsp;</b></p></div>
      @for (sprache of sprachen; track sprache) {
        <div class="col-sm-2.5 pl-0 mb-0"><p class="admin"><b>{{ sprache }}</b></p></div>
      }
    </div>
    @for (type of templateList.types; track type.id) {
      <div class="row admin">
        <div class="col-sm-4 pl-0 mb-0"><p class="admin"><b>{{ type.messageProperty | translate }}</b></p></div>
        @for (sprache of sprachen; track sprache) {
          <div class="col-sm-2.5 pl-0 mb-0">
            <p class="admin">
              <input class="hidden" type="file" accept=".docx" (change)="upload(type, sprache, $event)" #fileInput>
              <button class="btn btn-default" (click)="fileInput.click()"
                      matTooltipPosition="left" [matTooltip]="'admin.template.upload.tooltip' | translate">
                <i class="glyphicon glyphicon-arrow-up"></i>
              </button>
              <button class="btn btn-default ml-15" (click)="download(type, sprache)" [disabled]="!lastChanged(type, sprache)"
                      matTooltipPosition="right" matTooltipClass="line-break" [matTooltip]="downloadTooltip(type, sprache)">
                <i class="glyphicon glyphicon-arrow-down"></i>
              </button>
            </p>
          </div>
        }
      </div>
    }
    @if (uploadSuccess()) {
      <div class="row admin">
        <p class="admin-success"><b>{{ 'admin.template.upload.success' | translate:{file:uploadSuccess()} }}</b></p>
      </div>
    }
    @if (uploadError()) {
      <div class="row admin">
        <p class="admin-warning"><b>{{ 'admin.template.upload.error' | translate:{file:uploadError()} }}</b></p>
      </div>
    }
    @if (downloadError()) {
      <div class="row admin">
        <p class="admin-warning"><b>{{ 'admin.template.download.error' | translate:{file:downloadError()} }}</b></p>
      </div>
    }
    <div class="row admin mt-50">
      <button class="btn btn-default btn-sm" (click)="downloadDummy()"
              matTooltipPosition="right" [matTooltip]="'admin.template.dummy.tooltip' | translate">
        {{ 'admin.template.dummy.label' | translate }}
      </button>
    </div>
  }
</div>
